import * as generalAPI from '../../general/api';

export function getTrends(params) {
  return generalAPI.getTrends({ cloudType: 'vdc', ...params });
}

export function getAggregatedTestErrors(params) {
  return generalAPI.getAggregatedTestErrors({ cloudType: 'vdc', ...params });
}

export function getBuildsTests(params) {
  return generalAPI.getBuildsTests({ cloudType: 'vdc', ...params });
}

export function getTests(params) {
  return generalAPI.getTests({ cloudType: 'vdc', ...params });
}
